import { useEffect, useState } from "react";
import { Button, Form, Input, Modal, Select, Space, Table, message } from "antd";
import PageTitle from "../../components/PageTitle";
import {
  addAdminRoleMember,
  deleteAdminRoleMember,
  getAdminRoleMembers,
  getAdminRoles,
} from "../../api";

const RoleMembers = () => {
  const [roles, setRoles] = useState([]);
  const [roleId, setRoleId] = useState(null);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [form] = Form.useForm();

  const loadRoles = async () => {
    const res = await getAdminRoles();
    if (res?.success) {
      const list = res.data || [];
      setRoles(list);
      if (!roleId && list.length > 0) setRoleId(list[0].id);
    }
  };

  const loadMembers = async () => {
    if (!roleId) return;
    setLoading(true);
    try {
      const res = await getAdminRoleMembers(roleId);
      if (res?.success) setMembers(res.data || []);
      else message.error(res?.error || "加载成员失败");
    } catch {
      message.error("加载成员失败");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRoles();
  }, []);

  useEffect(() => {
    loadMembers();
  }, [roleId]);

  const handleAdd = async () => {
    const values = await form.validateFields();
    try {
      const res = await addAdminRoleMember({
        role_id: roleId,
        username: values.username,
        password: values.password || undefined,
        is_super_admin: false,
      });
      if (!res?.success) throw new Error(res?.error);
      message.success("已添加成员");
      setModalOpen(false);
      form.resetFields();
      loadMembers();
    } catch (e) {
      message.error(e?.message || "添加失败");
    }
  };

  const handleRemove = (row) => {
    Modal.confirm({
      title: `移除成员「${row.username}」？`,
      onOk: async () => {
        const res = await deleteAdminRoleMember(row.member_id);
        if (res?.success) {
          message.success("已移除");
          loadMembers();
        } else {
          message.error(res?.error || "移除失败");
        }
      },
    });
  };

  const columns = [
    { title: "账号", dataIndex: "username" },
    {
      title: "状态",
      dataIndex: "status",
      render: (s) => (s === 1 ? "正常" : "禁用"),
    },
    {
      title: "操作",
      width: 100,
      render: (_, row) => (
        <Button type="link" size="small" danger onClick={() => handleRemove(row)}>移除</Button>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title="角色成员" />
      <Space style={{ marginBottom: 12 }}>
        <Select
          style={{ width: 200 }}
          placeholder="选择角色"
          value={roleId}
          onChange={setRoleId}
          options={roles.map((r) => ({ label: r.name, value: r.id }))}
        />
        <Button type="primary" disabled={!roleId} onClick={() => setModalOpen(true)}>
          添加成员
        </Button>
      </Space>
      <Table rowKey="member_id" columns={columns} dataSource={members} loading={loading} size="small" />
      <Modal
        title="添加角色成员"
        open={modalOpen}
        onOk={handleAdd}
        onCancel={() => setModalOpen(false)}
        destroyOnClose
      >
        <Form form={form} layout="vertical">
          <Form.Item name="username" label="登录账号" rules={[{ required: true, message: "请输入账号" }]}>
            <Input placeholder="如：test" />
          </Form.Item>
          <Form.Item
            name="password"
            label="密码（新账号必填，至少6位）"
            rules={[{ min: 6, message: "至少6位" }]}
          >
            <Input.Password placeholder="已有账号可不填" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default RoleMembers;
